<div *ngIf="!isLoadingCategory">
  <mat-form-field
    appearance="outline"
    *ngIf="categoryMode == 'select'"
    class="w-full"
  >
    <mat-label>{{
      !isLoading ? "Category" : "Loading categories..."
    }}</mat-label>
    <mat-select
      (click)="_control.markAsUntouched()"
      [placeholder]="isLoading ? 'Loading...' : 'Select category'"
      (selectionChange)="selectCategoryObject($event)"
      [formControl]="_control"
    >
      <mat-option *ngFor="let option of categoryList" [value]="option">
        {{ option.name }}
      </mat-option>
    </mat-select>

    <button
      mat-icon-button
      matSuffix
      (click)="$event.preventDefault(); $event.stopPropagation()"
      [matMenuTriggerFor]="menu"
    >
      <mat-icon fontSet="material-icons-outlined">more_horiz</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button
        mat-menu-item
        type="button"
        (click)="categoryMode = 'add'; _modifyControl.setValue('')"
      >
        Add category
      </button>
      <button
        mat-menu-item
        type="button"
        *ngIf="_control.value != ''"
        (click)="
          _modifyControl.setValue(_control.value.name); categoryMode = 'edit'
        "
      >
        Edit category
      </button>
      <button
        mat-menu-item
        type="button"
        *ngIf="_control.value != ''"
        (click)="openConfirmModal()"
      >
        Remove category
      </button>
    </mat-menu>
    <mat-error *ngIf="ValidationHelperService.isInvalid(_control)">{{
      ValidationHelperService.getErrorMessage(_control)
    }}</mat-error>
  </mat-form-field>
  <mat-form-field
    appearance="outline"
    *ngIf="categoryMode != 'select'"
    class="w-full"
  >
    <mat-label>Category</mat-label>
    <input
      type="text"
      [formControl]="_modifyControl"
      matInput
      (focus)="_control.markAsUntouched()"
    />
    <div matSuffix class="d-flex justify-content-center align-items-center">
      <button
        mat-icon-button
        (click)="
          $event.preventDefault();
          $event.stopPropagation();
          categoryMode = 'select';
          updateAthleteCategory()
        "
        *ngIf="categoryMode == 'edit' && _modifyControl?.valid"
      >
        <mat-icon fontSet="material-icons-outlined">check</mat-icon>
      </button>
      <button
        mat-icon-button
        *ngIf="categoryMode == 'add' && _modifyControl?.valid"
        (click)="addAthleteCategory()"
      >
        <mat-icon fontSet="material-icons-outlined">check</mat-icon>
      </button>
      <button mat-icon-button (click)="closeCategory()">
        <mat-icon fontSet="material-icons-outlined">close</mat-icon>
      </button>
    </div>
    <mat-error *ngIf="ValidationHelperService.isInvalid(_modifyControl)">{{
      ValidationHelperService.getErrorMessage(_modifyControl)
    }}</mat-error>
  </mat-form-field>
</div>
